export const OPTIONS = [{ value: 'reward-info', label: 'Reward Info' }, { value: 'reward-by-email', label: 'Reward By Email' }]

export const HEADER_PROPERTIES = {
  tagName: 'div',
  layoutType: 'flex',
  flex: {
    direction: 'flex-row',
    distribute: 'justify-start',
    align: 'items-center',
    gap: {
      mobile: '2',
      desktop: '4',
    },
  },
  background: { color: 'white' },
  size: { width: 'w-full' },
}

export const SCOREBOARD_PROPERTIES = {
  tagName: 'div',
  layoutType: 'flex',
  flex: { direction: 'flex-col', gap: '4', distribute: 'justify-center', align: 'items-center' },
  space: { padding: 'p-8' },
  border: { radius: { rounded: 'md' }, width: { border: '2' }, color: 'gray-200' },
  shadow: { value: 'lg' },
}

export const completedProperties = color => ({
  layoutType: 'flex',
  flex: { align: 'items-center', distribute: 'justify-between' },
  space: {
    padding: 'p-6',
  },
  border: {
    radius: {
      rounded: 'md',
    },
    width: {
      border: "2",
    },
    color: `${color}-200`,
  },
  background: { color: `${color}-50` },
})

export const HEADER_OFFERS_PROPERTIES = {
  tagName: 'div',
  layoutType: 'flex',
  flex: { direction: 'flex-col', gap: '4', distribute: 'justify-center', align: 'items-center' },
  space: { padding: 'p-4' },
}

export const POINTS_PROPERTIES = {
  background: { color: 'green-50' },
  border: { color: 'green-200', width: { border: '2' }, radius: { rounded: 'md' } },
  space: { padding: 'p-2' },
  textColor: 'green-500',
  fontWeight: 'bold',
  fontSize: 'lg',
}

export const DESCRIPTION_PROPERTIES = {
  fontSize: 'lg',
  textColor: 'gray-500',
  content: 'You need to complete this step to get your points.',
}

export const FORM_PROPERTIES = {
  input: {
    attributes: { name: 'email', placeholder: 'Enter your email' },
    size: { width: 'w-sm' },
    border: {
      radius: { rounded: 'md' },
      width: { border: '1' }, color: 'gray-400',
    },
    space: { padding: 'p-2' },
  },
  button: {
    tagName: 'button',
    cursor: 'cursor-pointer',
    background: { color: 'blue-500' },
    textColor: 'gray-100',
    flexAlign: 'items-center',
    size: { width: 'w-full' },
    attributes: { type: 'button' },
    textAlign: { horizontal: 'center' },
    space: {
      padding: 'py-2 px-3',
    },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    content: 'Submit',
  },
  form: {
    tagName: 'form',
    attributes: {
      id: 'form',
      method: 'POST',
    },
    layoutType: 'flex',
    flex: { direction: 'flex-col', gap: '4' },
  },
}

export const HEADER_IMAGE_PROPS = {
  attributes: { src: '{{reward.img}}' },
  properties: {
    tagName: 'img',
    size: {
      width: 'w-auto',
      height: {
        mobile: 'h-20',
        desktop: 'h-30',
      },
    },
    customClassName: ['ml-auto'],
    customClassNameOptions: [{ label: 'ml-auto', value: 'ml-auto' }],
    attributes: {
      src: "https://images.unsplash.com/photo-1554629947-334ff61d85dc?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&h=1000&q=90",
    },
  },
  custom: {
    name: 'reward-header-image',
    suppressChildren: true,
    showImageProps: true,
    sidebarProps: [
      "customClassName",
      "contentUtility",
      "attributes[alt]",
      "attributes",
      "size",
      "background",
      "hide",
      "overflow",
      "position",
      "transition",
      "animation",
      "transform",
      "cursor",
      "nativeStyle",
      "filters",
      "imageAlign",
      "border",
      "ring",
      "outline",
      "shadow",
      "image.fit",
      "image.position",
    ],
  },
}

export const TRIGGER_PROPPERTIES = {
  hide: {
    mobile: {
      default: null,
      "peer-checked": null,
    },
  },
  space: {
    padding: "p-3",
  },
  border: {
    radius: {
      rounded: "md",
    },
  },
  cursor: "cursor-pointer",
  content: "Input",
  opacity: {
    checked: 77,
    default: null,
  },
  outline: {
    outline: "2",
  },
  rounded: {
    rounded: "2",
  },
  textAlign: {
    horizontal: "center",
  },
  textColor: "sky-200",
  transform: {
    after: "uppercase",
    default: null,
  },
  attributes: {
    type: "checkbox",
    className: "checked:opacity-77 after:font-['Roboto'] font-semibold rounded-md p-3 cursor-pointer appearance-none after:content-['Open_modal'] peer justify-center flex text-sky-200 after:uppercase bg-sky-700",
    placeholder: "Placeholderdf...",
  },
  background: {
    color: {
      after: null,
      checked: null,
      default: "sky-700",
    },
    blendMode: {
      checked: "",
      default: null,
    },
  },
  fontWeight: "semibold",
  nativeStyle: "appearance-none",
  outlineColor: "gray-400",
  contentUtility: {
    after: "Take Offers",
    default: null,
  },
  peerPropagation: true,
}

export const MODAL_PROPERTIES = {
  tagName: "div",
  position: {
    value: "fixed",
  },
  layoutType: "flex",
  flex: {
    wrap: "flex-nowrap",
    direction: "flex-row",
    distribute: "justify-center",
    align: "items-center",
  },
  size: {
    width: "w-screen",
    height: "h-screen",
  },
  background: {
    color: {
      hex: "#0000004e",
      rgba: {
        a: 0.31,
        b: 0,
        g: 0,
        r: 0,
      },
      rgbaParsed: "rgba(0,0,0,0.31)",
    },
  },
  animation: [
    {
      ease: "ease",
      name: "fadeIn",
      loops: 1,
      duration: "300",
    },
  ],
  customClassName: [
    "peer-checked:flex",
    "hidden",
    "inset-0",
    "z-50",
  ],
  customClassNameOptions: [
    { label: "peer-checked:flex", value: "peer-checked:flex" },
    { label: "hidden", value: "hidden" },
    { label: "inset-0", value: "inset-0" },
    { label: "z-50", value: "z-50" },
  ],
}

export const CONTENT_PROPERTIES = {
  tagName: "div",
  layoutType: "flex",
  flex: {
    wrap: "flex-nowrap",
    align: "items-center",
    direction: "flex-col",
    distribute: "justify-center",
  },
  size: {
    width: "w-full",
    height: "h-full",
  },
  position: {
    value: "relative",
  },
  customClassName: ["max-w-5xl", "z-10", "pointer-events-none"],
  customClassNameOptions: [
    { label: "max-w-5xl", value: "max-w-5xl" },
    { label: "z-10", value: "z-10" },
    { label: "pointer-events-none", value: "pointer-events-none" },
  ],
}

export const TAG_PROPERTIES = {
  tagName: "div",
  size: {
    width: {
      mobile: "w-screen",
      desktop: "w-full",
    },
    height: {
      mobile: "h-screen",
      desktop: "h-auto",
    },
    max: {
      height: {
        mobile: null,
        desktop: "max-h-[90vh]",
      },
    },
  },
  border: {
    radius: {
      rounded: {
        mobile: "none",
        desktop: "2xl",
      },
    },
  },
  background: {
    color: "white",
  },
  space: {
    padding: {
      mobile: null,
      desktop: "p-8",
    },
  },
  shadow: {
    value: "2xl",
  },
  customClassName: ["overflow-y-auto", "pointer-events-auto"],
  customClassNameOptions: [
    { label: "overflow-y-auto", value: "overflow-y-auto" },
    { label: "pointer-events-auto", value: "pointer-events-auto" },
  ],
}

export const CONTAINER_OFFERS_PROPERTIES = {
  tagName: 'div',
  layoutType: 'flex',
  flex: { direction: 'flex-col', gap: '4' },
  shadow: {
    value: 'lg',
  },
  border: {
    color: 'gray-200',
    width: { border: '2' },
    radius: {
      rounded: 'md',
    },
  },
}

export const OFFERS_HTML = `
{{>layout/dnd/status-page-script}}
`
